export enum MercerSurveyDecision {
  JobFamilyBasis = 'JobFamilyBasis',
  Default = 'Default'
}
